import React, { Suspense, Component } from 'react';
import HeadTags from '../global/headTags';
import timelineMapDataToComponents from '../../templates/timelineMapDataToComponents';
import TimelineCounters from './timelineCounters';
import TimelineIntro from './timelineIntro';
import TimelineProgress from './timelineProgress';
import ContentBackground from '../ui/contentBackground';
import TimelineBannerCallout from './timelineBannerCallout';
import Reveal from '../ui/reveal';
import SocialShare from '../global/socialShare';
import * as style from './timeline.module.scss';
import translations from '../../utils/translations';
import Loading from '../global/loading';


const ScrollReveal = props => {
  const isSSR = typeof window === "undefined";
  
  return (
    <>
    {!isSSR && (
      <Suspense fallback={<Loading/>}>
        <Reveal bottomOffset="50px">{props.children}</Reveal>
      </Suspense>
    )}
    </>
  );
};

class Timeline extends Component {
  constructor(props) {
    super(props);
    const bombCount = this.props.data.allItemsJson.edges[0].node.number_of_bombs;
    if (bombCount !== null) {
      this.state = { bombCount: bombCount };
    }
  }
  componentDidMount() {
    // force a rerender so the container element ref gets passed to the
    // progress component
    this.forceUpdate();
    window.addEventListener('scroll', this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }
  listeners = [];
  registerNodeListener = listenerFunction => {
    this.listeners.push(listenerFunction);
  };
  handleScroll = e => {
    this.scrollHeight =
      window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    this.listeners.forEach(listener => {
      listener(this.scrollHeight, windowHeight);
    });
  };
  updateCounts = bombCount => {
    if (typeof bombCount !== 'undefined' && bombCount !== null) {
      this.setState({
        bombCount,
      });
    }
  };

  render() {
    const {
      title,
      paragraphs,
      meta_description,
      featured_image,
      video,
      subtitle,
      next_timeline,
      id,
      timeline_group,
      label,
      number_of_bombs,
    } = this.props.data.allItemsJson.edges[0].node;
    return (
      <div
        style={this.props.transition && this.props.transition.style}
      >
        <HeadTags
          title={title}
          description={meta_description}
          image={featured_image ? featured_image.image.sizes.hero_md : null}
          imageTwitter={
            featured_image ? featured_image.image.sizes.hero_sm : null
          }
          location={this.props.location}
        />

        {timeline_group && (
          <aside className={style.sidebar}>
            <TimelineProgress
              currentId={id}
              timelineGroup={timeline_group}
              registerNodeListener={this.registerNodeListener}
              contentWrap={this.contentWrap}
            />
            {number_of_bombs !== null && (
              <TimelineCounters bombCount={this.state.bombCount} />
            )}
          </aside>
        )}

        <div className={style.timelineWrap}>
          <ContentBackground
            src={featured_image ? featured_image.image.sizes.hero_lg : ''}
            videoSrc={video ? video.url : ''}
            videoOpacity={0.4}
          />
          <div
            className={style.timelineContent}
            ref={el => {
              this.contentWrap = el;
            }}
          >
            <TimelineIntro
              title={title}
              label={label}
              subtitle={subtitle}
              introText={paragraphs[0].type === 'intro_text' && paragraphs[0]}
              isIE={this.props.isIE}
            />
            <div className={style.timelineContentInner}>
              {timelineMapDataToComponents(
                paragraphs,
                this.registerNodeListener,
                this.updateCounts,
                id
              )}
            </div>

            {next_timeline && (
              <ScrollReveal>
                <TimelineBannerCallout
                  callout_heading={next_timeline.title}
                  label={next_timeline.label}
                  key={`timelineFooter${id}`}
                  cta_link={{
                    url: next_timeline.path,
                    title: translations.t('Continue Reading'),
                  }}
                  src={
                    next_timeline.image ? next_timeline.image.sizes.wide_md : ''
                  }
                />
              </ScrollReveal>
            )}
          </div>
        </div>
        <SocialShare title={title} />
      </div>
    );
  }
}

export default Timeline;
